import { IItem } from "../items";
import { ExternalValidationResultAlert } from "../../../applications/documaker/domain/document";
import { AbstractDocumentAlert } from "./AbstractDocumentAlert";

export class ExternalValidateDocumentAlert extends AbstractDocumentAlert {
  constructor(private readonly _source: ExternalValidationResultAlert) {
    super(!_source || _source.isError);
  }

  get detectedItem(): IItem {
    return null;
  }

  get kind(): string {
    return this._source.kind;
  }

  get target(): string {
    return "文書";
  }

  get description(): string {
    return this._source.description;
  }

  get itemSetId(): number {
    return null;
  }
}
